export default [
  {
    id: 1,
    symbol: 'R$',
  },
  {
    id: 2,
    symbol: '%',
  },
];
